import { useContext, useEffect } from 'react';
import { stateContext } from './ctx';
import {hslToHex,generateRandomPoint,getRandom} from './functions'
import { icons } from './icons';

const Randomizer = () => {
	const {schema,setSchema,setBgColor} = useContext(stateContext)
    
	useEffect(()=>{
		document.body.onkeyup = function(e) {
			if (e.key === " " || e.code === "Space") {
				randomize()
			}
		  }
	},[])


	const randomize = () => {
		const r = getRandom;
		const l = schema.length;
		const composed = [];
		for (var u = 0; u < l; u++) composed.push(generateRandomPoint())
		
        setSchema(composed)
        setBgColor(hslToHex(r(0,360),100,80))			
		
	}
    return <div className='flex relative cursor-pointer p-3 gap-3 rounded-xl font-bold bg-mute-100 dark:bg-slate-800 text-slate-400 items-center' onClick={randomize}>Randomize {icons.refresh}</div>
}

export default Randomizer;